import CompSelectorInput from './index';
const CompSelectorInputMeta = {
  id: 'compSelectorInput',
  component: CompSelectorInput,
  isFormEditor: true,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true,
    checkData: s => s.type === 'string'
  }],
  slots: [{
    id: 'actions',
    type: 'normal'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string',
      title: '当前值'
    }, {
      id: 'placeholder',
      type: 'string'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '输入的 selector 表达式发生修改时触发，$event 为新的值'
  }]
};
export default CompSelectorInputMeta;
//# sourceMappingURL=meta.js.map
